import axios, { AxiosResponse, AxiosError } from "axios";
import {  toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const params = new URLSearchParams(window.location.search);
const token = params.get('token')
let isUnauthorizedHandled = false;
let isServerErrorHandled = false;

const handleUnauthorized = () => {
  if (isUnauthorizedHandled) return;
  isUnauthorizedHandled = true;

  localStorage.clear();
  toast.error("Login Expired.");

  if ((window as any).ReactNativeWebView) {
    (window as any).ReactNativeWebView.postMessage('logout');
  }
};

const handleServerError = () => {
  if (isServerErrorHandled) return;
  isServerErrorHandled = true;
  toast.error("Server Error");
};


export const startEndTripApi = (
  latitude: any,
  longitude: any,
  trip_id: any,
  vehicle_id: any,
  end_trip: number,
  successCallBack: (message: any) => void,
  errorCallBack: (errorMessage: any) => void,
  actionType: string,
  odometer_pic?: File,
  odometer_start?: any,
  odometer_end?: any,
  orders_picked?: any,
  orders_delivered?: any
) => {
  const formData = new FormData();

  if (latitude !== undefined && latitude !== null) {
    formData.append('latitude', String(latitude));
  }
  if (longitude !== undefined && longitude !== null) {
    formData.append('longitude', String(longitude));
  }
  if (trip_id !== undefined && trip_id !== null) {
    formData.append('trip_id', String(trip_id));
  }
  if (vehicle_id !== undefined && vehicle_id !== null) {
    formData.append('vehicle_id', String(vehicle_id));
  }
  formData.append('end_trip', String(end_trip));
  if (odometer_start) formData.append('odometer_start', String(odometer_start));
if (odometer_end) formData.append('odometer_end', String(odometer_end));
if (orders_picked) formData.append('orders_picked', String(orders_picked));
if (orders_delivered) formData.append('orders_delivered', String(orders_delivered));

if (odometer_pic) {
  formData.append('odometer_pic', odometer_pic);
}
  const headers = {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'multipart/form-data'
  };

  axios.post(
    `${global.api_url}/api/start_trip`,
    formData,
    { headers }
  )
  .then((response: AxiosResponse) => {
    if (response.data.status === 201 || response.data.status === 200 || response.data.status === 400) {
      successCallBack(response);
    }
  })
  .catch((error: AxiosError) => {
    if (error.response) {
      if (error.response.status === 400 || error.response.status === 404) {
        errorCallBack(error?.response?.data);
      } else if (error.response.status === 401) {
        handleUnauthorized();
      }
    } else {
    handleServerError();
    }
  });
};

  export const getDashboard = (
    _successCallBack: (response: any) => void,
    _errorCallBack: (errMessage: any) => void,
  ) => {
    const headers = {
      Authorization: `Bearer ${token}`
    };
    axios
      .get(`${global.api_url}/api/dashboard`, {
        headers: headers,
      })
      .then((response: AxiosResponse) => {
        if (response.status === 200) {
          _successCallBack(response.data);
        }
        else if (response.status === 201){
          _successCallBack(response.data);
        }
      })
      .catch((error: AxiosError) => {
        if (error.response?.status === 400) {
          _errorCallBack(error.response);
        }
        else if  (error.response?.status === 401){
          handleUnauthorized();
  
        }
        else if (error.response?.status === 404){
          _errorCallBack(error.response.data);
        }
        else{
          handleServerError();
        }
      });
  };
  export const vehicleUserMapping = (
 driver_id:any,
 vehicle_number:any,
 otp_verified:string,
 _successCallBack: (response: any) => void,
 _errorCallBack: (errMessage: any) => void,
  ) => {
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    let payload: any = {
driver_id:driver_id,
vehicle_number:vehicle_number,
otp_verified:otp_verified,
    };
  
    axios.put(
      `${global.api_url}/api/vehicles/${vehicle_number}`,
      payload,
      { headers }
    )
    .then((response: AxiosResponse) => {

      if (response.data.status === 201 || response.data.status === 200) {
        _successCallBack(response);
      }
      else if ( response.data.status === 400 ) {
        _successCallBack(response);
      }
    })
    .catch((error: AxiosError) => {
      if (error.response) {
        if (error.response.status === 400) {
          _errorCallBack(error?.response?.data);
        } else if (error.response.status === 404) {
          _errorCallBack(error?.response?.data);
        } else if (error.response.status === 401) {
          handleUnauthorized();
        }
      } else {
        handleServerError();
      }
    });
  };
  export const verifyOTP = (
    phone_number: any,
    country_code: any,
    otp:any,
    successCallBack: (message: any) => void,
    errorCallBack: (errorMessage: any) => void
  ) => {
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    const payload = {
      phone_number:phone_number,
      country_code:country_code,
      otp:otp
    };
    axios.post(
      `${global.api_url}/api/verify_otp`,
      payload,
      { headers }
    )
    .then((response: AxiosResponse) => {
      if (response.status === 201) {
        successCallBack(response);
      } 
      else if (response.status === 200) {
        successCallBack(response);
      } 
      else {successCallBack(response)
      }
    })
    .catch((error: AxiosError) => {
      if (error.response) {
        if (error.response.status === 400) {
          errorCallBack(error?.response?.data);
        } else if (error.response.status === 404){
          errorCallBack(error?.response?.data)
        }
        else if( error.response?.status === 404)
          {
            errorCallBack(error?.response?.data);
          }
        else if (error.response.status === 401) {
             handleUnauthorized();
        }
      } 
      else {
        handleServerError();
      }
    });
  };
  export const getOTP = (
    phone_number: any,
    country_code: any,
    from_register:any,
    successCallBack: (message: any) => void,
    errorCallBack: (errorMessage: any) => void
  ) => {
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    const payload = {
      phone_number:phone_number,
      country_code:country_code,
      from_register:from_register
    };
        axios.post(`${global.api_url}/api/generate_otp`, payload)
        .then((response: AxiosResponse) => {
         
            successCallBack(response);
         
        })
        .catch((error: AxiosError) => {
          if (error.response?.status === 400) {
            errorCallBack(error);
          }
          else if  (error.response?.status === 401){
            handleUnauthorized();
          }
          else{
            errorCallBack(error);
          }
        });
          }
          export const deleteAccount = (

              _successCallBack: (response: any) => void,
              _errorCallBack: (errMessage: any) => void
            ) => {
              const headers = {
                Authorization: `Bearer ${token}`,
              };
            
              axios
                .delete(`${global.api_url}/api/delete_account`, {
                  headers: headers,
            
                })
                .then((response: AxiosResponse) => {
                  if (response.status === 200) {
                    _successCallBack(response.data);
                  }
                  else if (response.status === 200) {
                    _successCallBack(response.data);
                  } 
                })
                .catch((error: AxiosError) => {
                  if (error.response?.status === 400) {
                    _errorCallBack(error.response.data);
                  } else if (error.response?.status === 401) {
                    handleUnauthorized();
                  }  else if( error.response?.status === 404)
                    {
                      _errorCallBack(error?.response?.data);
                    }
                  else {
                    handleServerError();
                  }
                });
            };
              export const editVehicle = (
                model:string,
                reg_date:string,
                number_plate:string,
                driver_id: string,
                owner_id: number,
                fuel_type:string,
                otp_verified:string,
                driver_switch:any,
                _successCallBack: (response: any) => void,
                _errorCallBack: (errMessage: any) => void
              ) => {
            
              const encodedNumberPlate = encodeURIComponent(number_plate);
              const payload = {
                driver_id,
                model,
                reg_date,
                owner_id,
                fuel_type,
                otp_verified,
                driver_switch
              };
                axios.put(`${global.api_url}/api/vehicles/${encodedNumberPlate}`, payload, {
                  headers: {
                    'Authorization': `Bearer ${token}`,
                  },
                })
                  .then((response: AxiosResponse) => {
                    if(response.status === 201) {
                    _successCallBack(response.data);
                  }
                    else if(response.status === 200) 
                  { _successCallBack(response.data);
                  }
                })
                  .catch((error: AxiosError) => {
                    if (error.response?.status === 400) {
                      console.log(error);
                      _errorCallBack(error.response.data);
                    } else if (error.response?.status === 401) {
                   handleUnauthorized();
                    } else if (error.response?.status === 500){
                      toast.error(error?.response?.message);
                    }
                    else if( error.response?.status === 404)
                      {
                        _errorCallBack(error.response.data);
                      }else {
                      handleServerError();
                    }
                  });
              };
            export const editTrips = (
              trip_id: any,
              remarks: string,
              orders_delivered: string,
              orders_picked: string,
              odometer_end: string,
              status: string,
              _successCallBack: (response: any) => void,
              _errorCallBack: (errMessage: any) => void
            ) => {
              try {
                const payload = {
                  remarks,
                  orders_delivered,
                  orders_picked,
                  odometer_end,
                  status,
                };
console.log(payload, status)
                axios
                  .put(`${global.api_url}/api/edit_trips/${trip_id}`, payload, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
                  .then((response: AxiosResponse) => {
                    if (response.status === 200 || response.status === 201) {
                      _successCallBack(response.data);
                    }
                  })
                  .catch((error: AxiosError) => {
                    if (error.response?.status === 400) {
                      console.log(error);
                      _errorCallBack(error.response.data);
                    } else if (error.response?.status === 401) {
                      handleUnauthorized();
                    } else if (error.response?.status === 500) {
                      toast.error((error.response?.data as any)?.message || "Server Error");
                    } else if (error.response?.status === 404) {
                      _errorCallBack(error.response.data);
                    } else {
                      handleServerError();
                    }
                  });
              } catch (err) {
                toast.error("Unexpected Error");
              }
            };
              export const getOrdersDelivered = (
                _successCallBack: (response: any) => void,
                _errorCallBack: (errMessage: any) => void,
              ) => {
                const headers = {
                  Authorization: `Bearer ${token}`
                };
                axios
                  .get(`${global.api_url}/api/dashboard/orders_delivered`, {
                    headers: headers,
                  })
                  .then((response: AxiosResponse) => {
                    if (response.status === 200) {
                      _successCallBack(response.data);
                    }
                    else if (response.status === 201){
                      _successCallBack(response.data);
                    }
                  })
                  .catch((error: AxiosError) => {
                    if (error.response?.status === 400) {
                      _errorCallBack(error.response);
                    }
                    else if  (error.response?.status === 401){
                      handleUnauthorized();
                    }
                    else if (error.response?.status === 404){
                      _errorCallBack(error.response.data);
                    }
                    else{
                     handleServerError();
                    }
                  });
              };
              export const editUser = (
              apk_version:any,
                _successCallBack: (response: any) => void,
                _errorCallBack: (errMessage: any) => void
              ) => {
                const payload = {
           apk_version
              };
                axios.put(`${global.api_url}/api/edit_user`, payload, {
                  headers: {
                    'Authorization': `Bearer ${token}`,
                  },
                })
                  .then((response: AxiosResponse) => {
                    if(response.status === 201) {
                    _successCallBack(response.data);
                  }
                    else if(response.status === 200) 
                  { _successCallBack(response.data);
                  }
                })
                  .catch((error: AxiosError) => {
                    if (error.response?.status === 400) {
                      console.log(error);
                      _errorCallBack(error.response.data);
                    } else if (error.response?.status === 401) {
                   handleUnauthorized();
                    } else if (error.response?.status === 500){
                      toast.error(error?.response?.message);
                    }
                    else if( error.response?.status === 404)
                      {
                        _errorCallBack(error.response.data);
                      }else {
                      handleServerError();
                    }
                  });
              };